import {EditOrderItems} from 'app/features/orders/componentsv1/edit'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import * as model from 'app/features/orders/redux/order/helper'
import * as action from 'app/features/orders/redux/order/refundSlice'
import find from 'lodash/find'
import React from 'react'
import isNaN from 'lodash/isNaN'

interface Props {
  children: React.ReactNode
  onValidate: (val: any) => void
}

export const FulfilledItems: React.FC<Props> = ({children, onValidate}) => {
  const dispatch = useDispatch()
  const orderItems = useSelector<RootState, any[]>(action.selectRefundItems)
  const deletedItems = useSelector<RootState, any[]>(action.selectDeletedItems)
  const isValidating = useSelector<RootState, boolean>(action.selectIsValidatingDiscount)

  const findItem = (orderItem: any) => {
    const item = find(orderItems, {variantId: orderItem.variantId})
    const deletedItem = find(deletedItems, {variantId: orderItem.variantId})
    return {item, deletedItem}
  }

  const handleRemoveItem = (orderItem: any) => {
    dispatch(action.removeOrderItem(orderItem.variantId))
    const deletedItem = find(deletedItems, {variantId: orderItem.variantId})
    if (!deletedItem) {
      dispatch(action.setDeletedItems([orderItem]))
    } else {
      onUpdateDeleteItem(orderItem, parseInt(deletedItem.quantity) + parseInt(orderItem.quantity))
    }
    onValidate(true)
    dispatch(action.setIsDirty(true))
  }

  const onUpdateItem = (orderItem: any) => {
    dispatch(
      action.updateOrderItem({
        id: orderItem.variantId,
        changes: {
          quantity: parseInt(orderItem.quantity),
        },
      })
    )
  }

  const onRemoveDeletedItem = (variantId: string) => {
    dispatch(action.setDeletedItems({type: model.actionType.remove, data: variantId}))
  }

  const onUpdateDeleteItem = (orderItem: any, quantity: number) => {
    dispatch(
      action.setDeletedItems({
        type: model.actionType.update,
        data: {...orderItem, quantity},
      })
    )
  }

  const handleUpdateItem = (orderItem: any) => {
    orderItem.quantity = parseInt(orderItem.quantity)

    if (isNaN(orderItem.quantity)) {
      orderItem.quantity = 0
    }

    const {item, deletedItem} = findItem(orderItem)
    let add = null

    if (item.quantity) {
      add = orderItem.quantity > item.quantity
    }

    onUpdateItem(orderItem)
    if (deletedItem) {
      const quantity = parseInt(item.originalQty) - orderItem.quantity
      if (quantity > 0) {
        onUpdateDeleteItem(orderItem, quantity)
      } else {
        onRemoveDeletedItem(orderItem.variantId)
      }
    } else if (add === false) {
      dispatch(
        action.setDeletedItems([
          {...orderItem, quantity: parseInt(orderItem.originalQty) - orderItem.quantity},
        ])
      )
    }
    onValidate(true)
    dispatch(action.setIsDirty(true))
  }

  return (
    <>
      {orderItems.length > 0 && (
        <EditOrderItems
          hideSearchBar
          title={
            <>
              Fulfilled ({orderItems.length}){' '}
              {isValidating && (
                <span className='indicator-progress d-block'>
                  <span className='spinner-border spinner-border spinner-border-sm align-middle ms-2 text-info'></span>
                </span>
              )}
            </>
          }
          items={orderItems}
          onRemoveItem={handleRemoveItem}
          onUpdateItem={handleUpdateItem}
          toolbar={children}
        />
      )}
    </>
  )
}

export default FulfilledItems
